module.exports = __webpack_public_path__ + "static/sprinter-icon-b7a3c722b56dd24b226ddc5c0c5e9383.jpg";